// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PublisherPage from './pages/PublisherPage';
import GuidePage from './pages/GuidePage';
import VolumeIssuePage from './pages/VolumeIssuePage';
import ArchivePage from './pages/ArchivePage';
import IssueDetailPage from './pages/IssueDetailPage';
import ManagementTeamPage from './pages/ManagementTeamPage';
import ManagementGovernance from './pages/ManagementGovernance';
import ContactPage from './pages/ContactPage';
import JournalPage from './pages/JournalPage';
import JournalsPage from './pages/JournalsPage';
import YoungEditorialPage from './pages/YoungEditorialPage';
import AuthorPage from './pages/GuidePage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import UnsubscribeMailPage from './pages/UnsubscribeMailPage';
import { UNSUBSCRIBE_PATH_CODE } from './utils/encodeEmailPath';
// 导入回到顶部组件
import ScrollToTopButton from './components/ScrollToTopButton';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/GlobalStyles.css';

function App() {
  return (
    <Router>
        <div>
          <Header/>
          <div className='body-dom' style={{
            height:"100vh",display:"flex",flexDirection:"column",
          }}>
          <main style={{marginTop:"60px",flex:"1"}}>
            <Routes>
              <Route path="/" element={<div className="container mt-4"><HomePage/></div>} />
              <Route path="/about/fargroups" element={<div className="container mt-4"><AboutPage /></div>} />
              <Route path="/publisher/:key" element={<div className="container mt-4"><PublisherPage /></div>} />
              <Route path="/about/management_team" element={<div className="container mt-4"><ManagementTeamPage /></div>} />
              <Route path="/about/management_governance" element={<div className="container mt-4"><ManagementGovernance /></div>} />
              <Route path="/about/contact_us" element={<div className="container mt-4"><ContactPage /></div>} />
              <Route path="/young_editorial" element={<div className="container mt-4"><YoungEditorialPage /></div>} />
              <Route path="/archives" element={<div className="container mt-4"><ArchivePage /></div>} />
              <Route path="/archive/:journalName" element={<div className="container mt-4"><ArchivePage /></div>} />
              <Route path="/issue/:jcr/:volumeId/:issueId" element={<div className="container mt-4"><IssueDetailPage /></div>} />
              <Route path="/journal/:journalId/guide" element={<div className="container mt-4"><GuidePage /></div>} />
              <Route path="/journal/:journalId" element={<div className="container mt-4"><JournalPage /></div>} />
              <Route path="/journals" element={<div className="container mt-4"><JournalsPage /></div>} />
              <Route path="/volume" element={<VolumeIssuePage />} />
              <Route path="/guide" element={<div className="container mt-4"><AuthorPage /></div>} />
              <Route path="/news" element={<div className="container mt-4"><NewsPage /></div>} />
              <Route path="/news/:id" element={<div className="container mt-4"><NewsDetailPage /></div>} />
              <Route path={`/${UNSUBSCRIBE_PATH_CODE}/unsubscribe-mail`} element={<div className="container mt-4"><UnsubscribeMailPage /></div>} />
              <Route path="*" element={<div className="container mt-4"><NotFoundPage /></div>} />
            </Routes>
            <ScrollToTopButton />
          </main>
          <Footer />
          </div>
        </div>
    </Router>
  );
}

export default App;